<template>
  <vs-row vs-w="12">
    <vs-col vs-w="12">
      <vs-row vs-w="12" class="my-2" v-if="policyLevel > POLICY_LEVEL.Venue">
        <vs-col vs-w="12">
          Policies from venue:<br /><show-policies-list
            :object-with-policies="getVenue()"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="my-2" v-if="policyLevel > POLICY_LEVEL.Setup">
        <vs-col vs-w="12">
          Policies from setup:<br /><show-policies-list
            :object-with-policies="getSetup()"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="my-2" v-if="policyLevel > POLICY_LEVEL.Section">
        <vs-col vs-w="12">
          Policies from section:<br /><show-policies-list
            :object-with-policies="getSection()"
          />
        </vs-col>
      </vs-row>

      <vs-row
        vs-w="12"
        class="mt-6"
        v-if="
          objectWithPolicies.venuePolicies == null ||
          objectWithPolicies.venuePolicies.length == 0
        "
      >
        <vs-col vs-w="12">
          <p>No policies added yet</p>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mt-6">
        <vs-col
          v-for="(
            policyOrSeatingStrategy, index
          ) in getPoliciesAndSeatingStrategies()"
          :key="'policy' + index"
          vs-lg="6"
          vs-sm="12"
          class="px-1"
        >
          <vs-card class="policy-card">
            <div slot="header">
              <p class="text-sm">
                <b>{{ getPolicyTypeName(policyOrSeatingStrategy) }}</b>
              </p>
            </div>
            <div class="p-3 pb-4">
              <edit-opening-hours-policy
                v-if="
                  policyOrSeatingStrategy.policyType == POLICY_TYPE.OpeningHours
                "
                :policy="policyOrSeatingStrategy"
              />
              <edit-booking-hours-policy
                v-if="
                  policyOrSeatingStrategy.policyType == POLICY_TYPE.BookingHours
                "
                :policy="policyOrSeatingStrategy"
              />
              <edit-min-spend-policy
                v-if="
                  policyOrSeatingStrategy.policyType == POLICY_TYPE.MinSpend
                "
                :policy="policyOrSeatingStrategy"
              />
              <edit-table-booking-policy
                v-if="
                  policyOrSeatingStrategy.policyType == POLICY_TYPE.TableBooking
                "
                :policy="policyOrSeatingStrategy"
              />
              <edit-seating-strategy-preferred-seating
                v-if="
                  policyOrSeatingStrategy.seatingStrategyType ==
                  SEATING_STRATEGY_TYPE.PreferredSeating
                "
                :seating-strategy="policyOrSeatingStrategy"
              />
              <edit-seating-strategy-prefe-high-table-capacity-usage
                v-if="
                  policyOrSeatingStrategy.seatingStrategyType ==
                  SEATING_STRATEGY_TYPE.PreferHighTableCapacityUsage
                "
                :seating-strategy="policyOrSeatingStrategy"
              />
            </div>
            <div slot="footer">
              <vs-row vs-w="12" vs-justify="flex-end">
                <vs-button
                  color="danger"
                  type="filled"
                  class="mb-2"
                  @click="removePolicy(policyOrSeatingStrategy)"
                >
                  Remove
                </vs-button>
              </vs-row>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12">
        <vs-col vs-w="12">
          <p>Add new policy</p>
          <div class="flex">
            <vs-select
              :placeholder="
                availablePolicyAndSeatingStrategyTypes
                  .length === 0
                  ? 'No more policies'
                  : 'Select Policy'
              "
              v-model="selectedPolicyOrSeatingStrategyType"
              :disabled="availablePolicyAndSeatingStrategyTypes.length === 0"
            >
              <vs-select-group title="Booking validation"
                v-if="availablePolicyTypes && availablePolicyTypes.length > 0">
                <vs-select-item
                  :key="index"
                  :value="policyType"
                  :text="POLICY_TYPE.nameof(policyType)"
                  v-for="(policyType, index) in availablePolicyTypes"
                />
              </vs-select-group>

              <vs-select-group title="Table ranking"
                v-if="availableSeatingStrategyTypes && availableSeatingStrategyTypes.length > 0">
                <vs-select-item
                  :key="index"
                  :value="seatingStrategyType"
                  :text="SEATING_STRATEGY_TYPE.nameof(seatingStrategyType)"
                  v-for="(
                    seatingStrategyType, index
                  ) in availableSeatingStrategyTypes"
                />
              </vs-select-group>
            </vs-select>

            <vs-button class="ml-2" @click="addPolicy()">Add policy</vs-button>
          </div>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import * as _ from "lodash";

import { mapGetters } from "vuex";
import EditOpeningHoursPolicy from "./openingHoursPolicy/EditOpeningHoursPolicy.vue";
import EditBookingHoursPolicy from "./bookingHoursPolicy/EditBookingHoursPolicy.vue";
import EditMinSpendPolicy from "./minSpendPolicy/EditMinSpendPolicy.vue";
import EditTableBookingPolicy from "./tableBookingPolicy/EditTableBookingPolicy.vue";
import EditSeatingStrategyPreferredSeating from "./seatingStrategyPreferredSeating/EditSeatingStrategyPreferredSeating.vue";
import EditSeatingStrategyPrefeHighTableCapacityUsage from "./seatingStrategyPrefeHighTableCapacityUsage/EditSeatingStrategyPrefeHighTableCapacityUsage";
import {
  POLICY_TYPE,
  POLICY_LEVEL,
  MinSpendPolicy,
  OpeningHoursPolicy,
  TableBookingPolicy,
  PolicyConfiguration,
  BookingHoursPolicy
} from "@/store/modules/marcom/data-model/policy-configurations";
import {
  SEATING_STRATEGY_TYPE,
  SeatingStrategyPreferredSeating,
  SeatingStrategyPreferHighTableCapacityUsage
} from "@/store/modules/marcom/data-model/seating-strategies";
import ShowPoliciesList from "./ShowPoliciesList.vue";

export default {
  props: {
    objectWithPolicies: Object,
    policyLevel: {
      type: Number,
      validator: function (value) {
        return (
          [
            POLICY_LEVEL.Venue,
            POLICY_LEVEL.Setup,
            POLICY_LEVEL.Section,
            POLICY_LEVEL.Table,
          ].indexOf(value) !== -1
        );
      },
    },
  },
  components: {
    EditOpeningHoursPolicy,
    EditBookingHoursPolicy,
    EditMinSpendPolicy,
    EditTableBookingPolicy,
    EditSeatingStrategyPreferredSeating,
    EditSeatingStrategyPrefeHighTableCapacityUsage,
    ShowPoliciesList,
  },
  data() {
    return {
      POLICY_TYPE,
      POLICY_LEVEL,
      SEATING_STRATEGY_TYPE,
      selectedPolicyOrSeatingStrategyType: null,
      policyTypes: POLICY_TYPE.getAll().filter(p => p !== POLICY_TYPE.BookingHours),
      seatingStrategyTypes: SEATING_STRATEGY_TYPE.getAll(),
    };
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
      activeVenueSetups: "marcom/activeVenueSetups",
    }),
    availablePolicyTypes() {
      let policyTypesInSetup = this.objectWithPolicies.venuePolicies.map(
        (p) => p.policyType
      );
      return this.policyTypes.filter((pt) => !policyTypesInSetup.includes(pt));
    },
    availableSeatingStrategyTypes() {
      let seatingStrategyTypesInSetup =
        this.objectWithPolicies.seatingStrategies.map(
          (p) => p.seatingStrategyType
        );
      return this.seatingStrategyTypes.filter(
        (pt) => !seatingStrategyTypesInSetup.includes(pt)
      );
    },
    availablePolicyAndSeatingStrategyTypes() {
      return this.availablePolicyTypes.concat(this.availableSeatingStrategyTypes);
    }
  },
  mounted() {},
  methods: {
    addPolicy() {
      if (!this.selectedPolicyOrSeatingStrategyType) return;

      switch (this.selectedPolicyOrSeatingStrategyType) {
        case POLICY_TYPE.OpeningHours: {
          let policy = new OpeningHoursPolicy(
            "New Opening Hours",
            this.policyLevel
          );
          this.objectWithPolicies.venuePolicies.push(policy);

          let policy2 = new BookingHoursPolicy(
            "Connected Booking Hours",
            this.policyLevel
          );
          this.objectWithPolicies.venuePolicies.push(policy2);
          break;
        }
        case POLICY_TYPE.MinSpend: {
          let policy = new MinSpendPolicy(
            "New Minimum Spend",
            this.policyLevel
          );
          this.objectWithPolicies.venuePolicies.push(policy);
          break;
        }
        case POLICY_TYPE.TableBooking: {
          let policy = new TableBookingPolicy(
            "New Table Booking",
            this.policyLevel
          );
          this.objectWithPolicies.venuePolicies.push(policy);
          break;
        }
        case SEATING_STRATEGY_TYPE.PreferredSeating: {
          let policy = new SeatingStrategyPreferredSeating(
            SeatingStrategyPreferredSeating.defaultValues()[0],
            this.policyLevel
          );
          this.objectWithPolicies.seatingStrategies.push(policy);
          break;
        }
        case SEATING_STRATEGY_TYPE.PreferHighTableCapacityUsage: {
          let policy = new SeatingStrategyPreferHighTableCapacityUsage(
            SeatingStrategyPreferHighTableCapacityUsage.defaultValue,
            this.policyLevel,
          );
          this.objectWithPolicies.seatingStrategies.push(policy);
          break;
        }
        default: {
          break;
        }
      }

      this.selectedPolicyOrSeatingStrategyType = null;
    },
    removePolicy(policyOrSeatingStrategy) {
      //to avoid javascript errors from vuesax,
      //a small timeout is added to let the button animate before being removed.
      setTimeout(() => {
        if (policyOrSeatingStrategy instanceof PolicyConfiguration) {
          const index = this.objectWithPolicies.venuePolicies.indexOf(
            policyOrSeatingStrategy
          );
          if (index >= 0)
            this.objectWithPolicies.venuePolicies.splice(index, 1);

          if(policyOrSeatingStrategy.policyType === POLICY_TYPE.OpeningHours) {
            const connectedPolicy = this.objectWithPolicies.venuePolicies.find(p => p.policyType === POLICY_TYPE.BookingHours);
            if(connectedPolicy) this.removePolicy(connectedPolicy);
          }
          else if(policyOrSeatingStrategy.policyType === POLICY_TYPE.BookingHours) {
            const connectedPolicy = this.objectWithPolicies.venuePolicies.find(p => p.policyType === POLICY_TYPE.OpeningHours);
            if(connectedPolicy) this.removePolicy(connectedPolicy);
          }
        } else {
          const index = this.objectWithPolicies.seatingStrategies.indexOf(
            policyOrSeatingStrategy
          );
          if (index >= 0)
            this.objectWithPolicies.seatingStrategies.splice(index, 1);
        }
      }, 10);
    },
    getPolicyTypeName(policyOrSeatingStrategy) {
      let currentPolicyOrSeatingStrategyType;
      if (policyOrSeatingStrategy instanceof PolicyConfiguration) {
        return POLICY_TYPE.nameof(policyOrSeatingStrategy.policyType);
      } else {
        return SEATING_STRATEGY_TYPE.nameof(
            policyOrSeatingStrategy.seatingStrategyType
          );
      }
    },
    getVenue() {
      return this.activeVenueDetails;
    },
    getSetup() {
      // is only called when  POLICY_LEVEL == Table or Section
      let setup = undefined;
      if (this.activeVenueSetups && this.activeVenueSetups.length > 0) {
        if (this.policyLevel === POLICY_LEVEL.Section) {
          setup = this.activeVenueSetups.find((set) => {
            if (set.venueSections && set.venueSections.length > 0) {
              let index = set.venueSections.findIndex(
                (sec) => sec.id === this.objectWithPolicies.id
              );
              if (index > -1) {
                return set;
              }
            }
            return undefined;
          });
        } else {
          // POLICY_LEVEL == Table
          let section = this.getSection();
          setup = this.activeVenueSetups.find((set) =>
            set.venueSections.map((sec) => sec.id).includes(section.id)
          );
        }
      }
      return setup;
    },
    getSection() {
      // is only called when POLICY_LEVEL == Table
      let section = undefined;
      if (this.activeVenueSetups && this.activeVenueSetups.length > 0) {
        let found = false;
        let index = 0;
        while (!found && index < this.activeVenueSetups.length) {
          let setup = this.activeVenueSetups[index];
          if (setup.venueSections && setup.venueSections.length > 0) {
            section = setup.venueSections.find((sec) => {
              if (sec.venueTables && sec.venueTables.length > 0) {
                let table = sec.venueTables.find(
                  (t) => t.id === this.objectWithPolicies.id
                );
                return table;
              }
              return undefined;
            });

            if (section) {
              found = true;
            }
          }
          index++;
        }
      }

      return section;
    },
    getPoliciesAndSeatingStrategies() {
      return this.objectWithPolicies.venuePolicies.filter(p => POLICY_TYPE.getAll().includes(p.policyType))
        .concat(
            this.objectWithPolicies.seatingStrategies.filter(s => SEATING_STRATEGY_TYPE.getAll().includes(s.seatingStrategyType))
        );
    }
  },
};
</script>

<style lang="scss" scoped>
.policy-card::v-deep .vs-card--header {
  background-color: #cccccc;
}

.vs-select-group::v-deep {
  h4 {
    font-size: 1.1rem;
  }
}
</style>
